/**
 * Path helpers for git-friendly YAML workspace trees.
 */

export function normalizeRootPath(rootPath) {
  return String(rootPath || '').replace(/\\/g, '/').replace(/\/+$/, '');
}

export function slugify(name, id) {
  const base =
    String(name || 'item')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'item';
  const suffix = String(id || '')
    .replace(/[^a-z0-9-]/gi, '')
    .slice(0, 8);
  return suffix ? `${base}-${suffix}` : base;
}

export function workspaceManifestPath(root) {
  return `${normalizeRootPath(root)}/apiboo.yaml`;
}

export function variablesGlobalsPath(root) {
  return `${normalizeRootPath(root)}/variables/globals.yaml`;
}

export function variablesWorkspacePath(root) {
  return `${normalizeRootPath(root)}/variables/workspace.yaml`;
}

export function environmentPath(root, envSlug) {
  return `${normalizeRootPath(root)}/environments/${envSlug}.yaml`;
}

export function collectionDir(root, collectionSlug) {
  return `${normalizeRootPath(root)}/collections/${collectionSlug}`;
}

export function collectionMetaPath(root, collectionSlug) {
  return `${collectionDir(root, collectionSlug)}/collection.yaml`;
}

export function requestPath(root, collectionSlug, requestSlug) {
  return `${collectionDir(root, collectionSlug)}/requests/${requestSlug}.yaml`;
}

export function gitignorePath(root) {
  return `${normalizeRootPath(root)}/.gitignore`;
}
